import http from "@/api/http.js";

export function getRecoveryEmail(email) {
  return http.post(`/administrators/password_link`, { email }).then(res => {
    return res;
  });
}

export function updatePassword(token, password) {
  return http.post(`/administrators/restore_password`, { token, password });
}
